//export const ApiAdress="http://localhost:5000/";
export const ApiAdress = process.env.REACT_APP_API_URL || "https://edergipanel.semerkanddijital.com.tr/";
//export const ApiAdress="https://edergiportal-dergitest.azurewebsites.net/";